module.exports = __webpack_public_path__ + "img/aptuscare-dash-logo.7f6a1eda.png";